import { render, staticRenderFns } from "./HeartysanCategoryMobileTable.vue?vue&type=template&id=e84fb8f2&scoped=true"
import script from "./HeartysanCategoryMobileTable.vue?vue&type=script&lang=js"
export * from "./HeartysanCategoryMobileTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84fb8f2",
  null
  
)

export default component.exports